module.exports = __webpack_public_path__ + "img/evri.83c2e7d9.png";